import { Box, Menu } from '@mantine/core'
import { MoreVertical, Pencil, Share2 } from 'lucide-react'

import { cn } from 'src/utils'

const CustomTab = ({
  selectedTab,
  value,
  label,
  setSelectedTab = (_value) => {},
  onClick = () => {},
  className = '',
  showCloseButton = false,
  onClose = () => {},
  onShare = null,
  variant = 'default',
}: {
  selectedTab: string
  value: string
  label: React.ReactNode
  setSelectedTab?: (value: string) => void
  onClick?: () => void
  className?: string
  showCloseButton?: boolean
  onClose?: () => void
  onShare?: (() => void) | null
  variant?: 'default' | 'title' | 'compact' | 'segmented'
}) => {
  const isSelected = selectedTab === value

  const getVariantStyles = () => {
    if (variant === 'title') {
      return cn(
        'group relative flex flex-row items-center justify-center gap-1 text-nowrap p-1 text-xs hover:cursor-pointer uppercase tracking-wide',
        isSelected
          ? 'font-normal text-doubleNickel-gray-500'
          : 'font-normal text-doubleNickel-gray-400 hover:text-doubleNickel-gray-500'
      )
    }

    if (variant === 'compact') {
      return cn(
        'group relative flex flex-row items-center justify-center gap-1 text-nowrap rounded px-2 py-1 text-xs hover:cursor-pointer hover:bg-doubleNickel-gray-50',
        isSelected && 'bg-doubleNickel-gray-100 font-medium'
      )
    }

    if (variant === 'segmented') {
      return cn(
        'group relative flex flex-row items-center justify-center gap-1 text-nowrap rounded-md px-3.5 py-1.5 text-xs hover:cursor-pointer transition-all duration-150',
        isSelected
          ? 'bg-white font-medium text-doubleNickel-gray-900 shadow-sm'
          : 'text-doubleNickel-gray-500 hover:text-doubleNickel-gray-700'
      )
    }

    return cn(
      'group relative flex flex-row items-center justify-center gap-1 text-nowrap rounded p-2 text-sm hover:cursor-pointer hover:bg-doubleNickel-gray-50',
      isSelected && 'bg-doubleNickel-gray-100 font-medium'
    )
  }

  return (
    <Box
      className={cn(getVariantStyles(), className)}
      onClick={() => {
        setSelectedTab(value)
        onClick()
      }}
    >
      {label}
      {showCloseButton && (
        <Menu shadow="md" width={120} position="bottom-end" offset={4}>
          <Menu.Target>
            <button
              className="absolute -right-2 -top-0 z-50 rounded-full bg-white p-0.5 opacity-0 shadow-lg transition-opacity duration-200 group-hover:opacity-100"
              onClick={(e) => {
                e.stopPropagation()
              }}
            >
              <MoreVertical className="h-3 w-3 text-gray-600 hover:text-doubleNickel-gray-900" />
            </button>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              leftSection={<Pencil className="h-3 w-3" />}
              onClick={(e) => {
                e.stopPropagation()
                onClose()
              }}
            >
              Edit
            </Menu.Item>
            {onShare && (
              <Menu.Item
                leftSection={<Share2 className="h-3 w-3" />}
                onClick={(e) => {
                  e.stopPropagation()
                  onShare()
                }}
              >
                Share
              </Menu.Item>
            )}
          </Menu.Dropdown>
        </Menu>
      )}
    </Box>
  )
}

export default CustomTab
